import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';
import Contact from '../components/Contact';
import SEO, { organizationJsonLd, breadcrumbJsonLd } from '../components/SEO';

const AboutPage = ({ onRequestDemo, onRequestQuote }) => (
  <div className="min-h-screen bg-white">
    <SEO
      title="About CTRL Systems — ctrl.aero"
      description="CTRL Systems partners with aviation OEMs, operators, and MROs to bring ultrasonic detection, acoustic imaging, and thermal imaging into aircraft maintenance. Our mission, values, and team."
      canonical="https://ctrl.aero/about"
      jsonLd={[
        organizationJsonLd,
        breadcrumbJsonLd([
          { name: 'Home', url: 'https://ctrl.aero/' },
          { name: 'About', url: 'https://ctrl.aero/about' },
        ]),
      ]}
    />
    <Header onRequestDemo={onRequestDemo} onRequestQuote={onRequestQuote} />

    <section className="relative isolate overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 pt-24 pb-12 sm:pt-28 sm:pb-14">
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-blue-500/20 blur-3xl" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <Link to="/" className="inline-flex items-center text-white/70 hover:text-white text-sm mb-6 transition-colors" data-testid="about-back-home">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to Home
        </Link>
        <p className="text-orange-400 text-xs sm:text-sm font-semibold uppercase tracking-wide mb-2">Company</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-3xl">About CTRL Systems</h1>
        <p className="mt-4 text-base sm:text-lg text-blue-100/85 leading-relaxed max-w-prose">
          Ultrasonic, acoustic, and thermal diagnostics for aviation maintenance — built with OEMs, proven on the flightline.
        </p>
      </div>
    </section>

    <About />
    <div className="h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent"></div>
    <Contact initialFormType={null} />
    <Footer />
  </div>
);

export default AboutPage;
